import React from "react";
// import "./loader.css";
export default function Loader() {
  return (
    <div style={{ height: "600px" }}>
      <div className="loading-spinner"></div>
    </div>
  );
}
